import React, { useState } from "react";
import { BASE_URL } from "../../config/api";

export default function ChangePassword({ isOpen, onClose, onLogout }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userid = user?.id;

  if (!isOpen) return null;

  const changePassword = async () => {
    if (!userid) {
      alert("User ID not found");
      return;
    }

    if (!password.trim()) {
      alert("Enter New Password");
      return;
    }

    if (!confirmPassword.trim()) {
      alert("Enter Confirm Password");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      const formData = new URLSearchParams();

      formData.append("userid", userid);
      formData.append("password", password);

      const response = await fetch(`${BASE_URL}/change_password.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      const text = await response.text();

      // console.log("CHANGE PASSWORD RAW:", text);

      let result;

      try {
        result = JSON.parse(text);
      } catch (err) {
        alert("Invalid server response");
        return;
      }

      // console.log("CHANGE PASSWORD RESULT:", result);

      // SUCCESS ONLY
      if (
        result.status === true ||
        result.success === true ||
        result.Status === true
      ) {
        alert("Password Changed Successfully");

        localStorage.removeItem("user");
        localStorage.removeItem("token");

        window.dispatchEvent(new Event("userLogout"));

        setPassword("");
        setConfirmPassword("");

        onLogout?.();
        onClose?.();
      } else {
        // FAILED API
        alert(result.message || "Password change failed");
      }
    } catch (error) {
      console.error("CHANGE PASSWORD ERROR:", error);

      alert("Server Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-popup-overlay">
      <div className="login-popup-card">
        <button className="login-popup-close" onClick={onClose}>
          ✕
        </button>

        <div className="login-header">
          <h2>Change Password</h2>
        </div>

        {/* NEW PASSWORD */}
        <div className="login-popup-form-group">
          <label>New Password</label>

          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              className="login-popup-input"
              placeholder="Enter New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ paddingRight: "45px" }}
            />

            <i
              className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            />
          </div>
        </div>

        {/* CONFIRM PASSWORD */}
        <div className="login-popup-form-group">
          <label>Confirm Password</label>

          <div style={{ position: "relative" }}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="login-popup-input"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{ paddingRight: "45px" }}
            />

            <i
              className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"}`}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            />
          </div>
        </div>

        <button
          className="login-popup-btn"
          onClick={changePassword}
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Change Password"}
        </button>
      </div>
    </div>
  );
}
